import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import { AnalyticsPlanningStore } from '../types/store';
import { sortBoardSetsRoutine } from '../actions';
import initialState from '../store';
import { AnalyticsBoardSetModel } from '@common/types/dictionaries/analytics';

export const sortBoardSetsReducer = createReducer<AnalyticsPlanningStore>(initialState as AnalyticsPlanningStore, {
  [sortBoardSetsRoutine.REQUEST]: (state) => {
    return state;
  },
  [sortBoardSetsRoutine.SUCCESS]: (
    state,
    action: PayloadAction<{
      data: AnalyticsBoardSetModel[];
    }>
  ) => {
    const { data } = action.payload;

    if (data.length && state.BoardSets?.data) {
      const res = {};

      for (let item of data) {
        res[item.ID] = item;
      }

      state.BoardSets.data = res;
    }

    return state;
  },
  [sortBoardSetsRoutine.FAILURE]: (state) => {
    return state;
  },
  [sortBoardSetsRoutine.FULFILL]: (state, action: PayloadAction<any>) => {
    state.Boards.isFetching = false;
    return state;
  }
});
